<template>
  <v-dialog v-model="open" max-width="420" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header gm-dialog-header--danger d-flex align-center px-8 py-6">
        <div class="text-h5">
          <span style="color: #3a68ff;">删除</span><span>确认</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-2 pb-4">
        <div class="text-body-1">
          <template v-if="kind === 'elink' && target">
            确定删除「{{ target.name }}」吗？其下 eBlock 将一并删除。
          </template>
          <template v-else-if="kind === 'eblock' && target">
            确定删除 eBlock「{{ target.eblock?.name }}」吗？
          </template>
          <template v-else-if="kind === 'elink-water-machine' && target">
            确定删除 eLink 水机「{{ target.name }}」（{{ target.uuid }}）吗？
          </template>
          <template v-else-if="kind === 'elink-meter' && target">
            确定删除计量电表「{{ target.meterName }}」（{{ target.uuid }}）吗？
          </template>
          <template v-else-if="kind === 'meter' && target">
            确定删除电表「{{ target.meterName }}」（{{ target.uuid }}）吗？
          </template>
          <template v-else-if="kind === 'transformer' && target">
            确定删除变压器「{{ target.transformerName }}」（{{ target.uuid }}）吗？
          </template>
          <template v-else-if="kind === 'pv' && target">
            确定删除光伏「{{ target.photovoltaicName }}」（{{ target.uuid }}）吗？
          </template>
          <template v-else-if="kind === 'pile' && target">
            确定删除充电桩「{{ target.chargePileName }}」（{{ target.uuid }}）吗？
          </template>
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="emit('close')">取消</v-btn>
        <v-btn color="#3a68ff" variant="flat" class="gm-btn-primary px-10 text-white" @click="emit('confirm')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
const open = defineModel({ type: Boolean, default: false })
defineProps({
  kind: { type: String, default: '' },
  target: { type: Object, default: null },
})
const emit = defineEmits(['close', 'confirm'])
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
